import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";


interface IAuthenticationForms {
  children: ReactNode,
  className?: string
}


const AuthenticationForms: FC<IAuthenticationForms> = ({ children, className }) => {
  const { i18n } = useTranslation();

  return (

    <div className={`login-wrapper ${className} ${i18n.language}`}>
      <div className="auth-module-container">
        <div className="form-container">
          <div className="login-content">{children}</div>
        </div>
        <div className="auth-img-container">
          {/* <img className="auth-img" src="./images/Auth-img.png"/> */}
        </div>
      </div>
    </div>
  );
};

export default AuthenticationForms;
